// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"342":"2ba5c86e","794":"0ccf4650"}[chunkId] + ".chunk.css";
};